<template>
  <Layout>
    <div style="width: 100%;">
      <q-card class="flexbox justify-center" style="min-height: 250px;">
        <q-card-section>
          <div class="flex justify-between">
            <div>
              <div class="text-h6">Price alerts</div>
              <div class="text-caption" v-if="permit !== null">
                You have the right to create {{ permit }} alert{{ permit > 1 ? 's' : '' }}.
              </div>
            </div>
            <div>
              <q-btn round color="green" icon="fas fa-plus" @click="showModalForm()" style="margin-top: 5px;">
                <q-tooltip>Create new</q-tooltip>
              </q-btn>
            </div>
          </div>
        </q-card-section>

        <q-separator/>

        <q-card-section style="min-height: 200px;">
          <loading v-if="loading"></loading>
          <div v-if="items.length > 0 && !loading">
            <q-table ref="table"
                     :data="items"
                     :columns="columns"
                     :pagination.sync="pagination"
                     row-key="name"
                     class="no-shadow">
              <template v-slot:body="props">
                <q-tr :props="props">
                  <q-td key="period_type" :props="props" style="width: 25%">
                    <span>{{ getPriceAlertPeriodLabelByValue(props.row.period_type) }}</span>
                  </q-td>
                  <q-td key="change_type" :props="props" style="width: 25%">
                    <span style="margin-right: 3px;">{{ getPriceAlertChangeLabelByValue(props.row.change_type) }}</span>
                    <i :class="`fas fa-arrow-${props.row.change_type === 'decrease' ? 'down' : 'up'}`"
                       :style="`font-size: 11px; color: ${props.row.change_type === 'decrease' ? 'red' : 'green'}`"></i>
                  </q-td>
                  <q-td key="value" :props="props" style="width: 25%">{{ props.row.value }}%</q-td>
                  <q-td key="amount" :props="props" style="width: 25%">{{ props.row.amount }}</q-td>
                  <q-td key="createdAt" :props="props" style="width: 25%">{{ props.row.createdAt | dateTimeFormat }}</q-td>
                  <q-td key="dueDate" :props="props" style="width: 25%">{{ props.row.dueDate | dateFormat }}</q-td>
                  <q-td key="paidAt" :props="props" style="width: 25%">
                    <q-chip square color="red" text-color="white" label="Unpaid" v-if="props.row.paidAt === null"/>
                    <q-chip square color="green" text-color="white" label="Paid" v-else/>
                  </q-td>
                  <q-td key="id" :props="props">
                    <q-btn round
                           size="sm"
                           @click="showModalForm(props.row.id)"
                           class="q-mr-sm"
                           color="orange"
                           icon="fas fa-pen">
                      <q-tooltip>Update</q-tooltip>
                    </q-btn>
                    <q-btn round
                           size="sm"
                           @click="onDelete(props.row.id)"
                           class="q-mr-sm"
                           color="red"
                           icon="fas fa-trash">
                      <q-tooltip>Delete</q-tooltip>
                    </q-btn>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </div>
          <p class="text-center" v-if="items.length === 0 && !loading">Price alert not found.</p>
        </q-card-section>
      </q-card>
      <price-alert-modal></price-alert-modal>
      <q-dialog v-model="deleteConfirm" persistent>
        <q-card>
          <q-card-section class="row items-center">
            <span class="q-ml-sm">Are you sure delete this item?</span>
          </q-card-section>
          <q-card-actions align="right">
            <q-btn label="Yes" color="red" @click="handleDelete"/>
            <q-btn label="No" color="primary" v-close-popup/>
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import axios from '../axios/index'
import {getPriceAlertChangeLabelByValue, getPriceAlertPeriodLabelByValue} from "@/enums";
import PriceAlertModal from "@/components/PriceAlertModal.vue";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    Layout,
    Loading,
    PriceAlertModal,
  },
  data() {
    return {
      loading: true,
      pagination: {
        sortBy: 'period_type',
        descending: false,
        page: 1,
        rowsPerPage: 10
      },
      columns: [
        {name: 'period_type', label: 'Period', field: 'period_type', sortable: true},
        {name: 'change_type', label: 'Change type', field: 'change_type', sortable: true},
        {name: 'value', label: 'Value', field: 'value', sortable: true},
        {name: 'createdAt', label: 'Created at', field: 'createdAt', sortable: true},
        {name: 'id', label: 'Actions', field: 'id'},
      ],
      permit: null,
      items: [],
      deleteConfirm: false,
      deleteId: null,
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.state.priceAlert.modal;
      },
      set(val) {
        this.$store.commit('priceAlert/SET_MODAL', val);
      },
    },
    refreshRequired: {
      get() {
        return this.$store.state.priceAlert.refreshRequired;
      },
      set(val) {
        this.$store.commit('priceAlert/SET_REFRESH_REQUIRED', val);
      },
    },
    user: {
      get() {
        return this.$store.state.profile.user;
      },
      set(val) {
        this.$store.commit('profile/SET_USER', val);
      },
    }
  },
  mounted() {
    this.getPriceAlerts()
  },
  methods: {
    getPriceAlertChangeLabelByValue,
    getPriceAlertPeriodLabelByValue,
    getAlertLabelByValue: getPriceAlertPeriodLabelByValue,
    async getPriceAlerts() {
      try {
        this.items = []
        this.loading = true
        const {data} = await axios.get('/price-alerts')

        if (data.data.length > 0) {
          for (const key in data.data) {
            this.items.push({
              period_type: data.data[key].period_type,
              change_type: data.data[key].change_type,
              value: data.data[key].value,
              createdAt: data.data[key].created_at,
              id: data.data[key].id,
            })
          }
        }
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.permit = this.user.price_alert_permit_count - this.items.length
        this.loading = false
      }
    },
    showModalForm(id) {
      this.modal = {
        show: true,
        id: id
      }
    },
    onDelete(id) {
      this.deleteConfirm = true;
      this.deleteId = id;
    },
    async handleDelete() {
      try {
        const response = await axios.delete(`/price-alert/${this.deleteId}`)
        if (response.status === 200) {
          this.items = this.items.filter(item => item.id !== this.deleteId)
        }
        this.$q.notify({
          message: response.data.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } catch (e) {
        this.$q.notify({
          message: 'Something went wrong. Please try again.',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } finally {
        this.deleteConfirm = false
        this.deleteId = null
      }
    }
  },
  watch: {
    refreshRequired() {
      if (this.refreshRequired) {
        this.refreshRequired = false;
        this.getPriceAlerts();
      }
    },
    user() {
      this.permit = this.user.price_alert_permit_count - this.items.length
    }
  }
}
</script>
